export type PromoCodeVerification ={
  code:string,
  description:string;
  discountType:DiscountType;
  discountValue:number;
  maxDiscountAmount: null | number;
  startDate:Date;
  endDate: null | Date;
  isActive:boolean;
}
export enum DiscountType { 
    Percentage = 0,
    FixedAmount = 1,
    FreeTrial = 2
}